import { render, staticRenderFns } from "./StakeMusicPlayer.vue?vue&type=template&id=859894da&scoped=true&"
import script from "./StakeMusicPlayer.vue?vue&type=script&lang=ts&"
export * from "./StakeMusicPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./StakeMusicPlayer.vue?vue&type=style&index=0&id=859894da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859894da",
  null
  
)

export default component.exports